import type { CrosshairSyncData } from '../types/chart'

/** This chart's crosshair channel membership (which sync channels it's on). */
export interface CrosshairChannels {
  /** This chart's symbol — required for the ticker channel to match. */
  symbol?: string
  /** Connected to the same-ticker channel. */
  ticker: boolean
  /** Connected to the global (cross-ticker, by-time) channel. */
  global: boolean
}

/**
 * Decide whether an incoming crosshair broadcast should be applied to THIS
 * chart, given the two independent sync channels:
 *
 *  - **Ticker channel**: apply if both ends are on it AND share the same symbol.
 *  - **Global channel**: apply if both ends are on it (any symbol — the
 *    cross-ticker "sympathy" club, aligned by timestamp).
 *
 * Apply if EITHER channel matches. Symbol-less charts never match on the ticker
 * channel (two undefined symbols are not "the same ticker").
 */
export function shouldApplyCrosshair(data: CrosshairSyncData, self: CrosshairChannels): boolean {
  const tickerMatch =
    self.ticker && !!data.tickerSync && self.symbol != null && data.symbol === self.symbol
  const globalMatch = self.global && !!data.globalSync
  return tickerMatch || globalMatch
}
